import React from 'react';
const SvgF3D = React.forwardRef((rest, ref) => {
  const props = { ...rest, ref };
  return (
    <svg width="1em" height="1em" viewBox="0 0 32 32" {...props}>
      <defs>
        <radialGradient
          cx="59.066%"
          cy="45.856%"
          fx="59.066%"
          fy="45.856%"
          r="54.917%"
          gradientTransform="matrix(0 -.74504 1 0 .132 .899)"
          id="f3d_svg__d"
        >
          <stop stopColor="#AB8052" offset="0%" />
          <stop stopColor="#AB8052" offset="23.16%" />
          <stop stopColor="#FCBB5F" offset="100%" />
        </radialGradient>
        <radialGradient
          cx="69.93%"
          cy="-19.257%"
          fx="69.93%"
          fy="-19.257%"
          r="185.902%"
          gradientTransform="scale(-.30467 -1) rotate(-44.491 -.327 3.66)"
          id="f3d_svg__e"
        >
          <stop stopColor="#AB8052" offset="0%" />
          <stop stopColor="#AB8052" offset="50.633%" />
          <stop stopColor="#FDBC5F" offset="100%" />
        </radialGradient>
        <radialGradient
          cx="81.627%"
          cy=".386%"
          fx="81.627%"
          fy=".386%"
          r="233.212%"
          gradientTransform="matrix(.44105 0 0 .78945 .456 0)"
          id="f3d_svg__f"
        >
          <stop stopColor="#DD852F" offset="0%" />
          <stop stopColor="#8E5623" offset="100%" />
        </radialGradient>
        <linearGradient x1="50%" y1="-17.099%" x2="17.37%" y2="87.754%" id="f3d_svg__a">
          <stop stopColor="#A75726" offset="0%" />
          <stop stopColor="#DE8530" offset="58.229%" />
          <stop stopColor="#9A5E26" offset="100%" />
        </linearGradient>
        <linearGradient x1="73.189%" y1="22.255%" x2="27.145%" y2="70.097%" id="f3d_svg__c">
          <stop stopColor="#A75726" offset="0%" />
          <stop stopColor="#DE8530" offset="61.909%" />
          <stop stopColor="#9A5E26" offset="100%" />
        </linearGradient>
        <path
          d="M2.153 4.285c2.47-2.508 7.656-.847 7.656-.847S9.463 1.83 9.295 1.21C9.232.978 9.1.856 8.918.813 6.283.191 2.487.041 2.413.036c.03.028-5.724 4.925 1.621 16.33-.964-2.058-4.697-9.222-1.881-12.08z"
          id="f3d_svg__b"
        />
      </defs>
      <g fill="none" fillRule="evenodd">
        <path fill="#FDBC5F" d="M3 31h26V8h-7V1H3z" />
        <path fill="#FFF" d="M4 2v20h24V8h-6V2z" />
        <path fill="#92571E" opacity={0.2} d="M29 15l-7-7h7z" />
        <path fill="#DA822F" d="M22 1l7 7h-7z" />
        <path
          d="M7.78 19.103c-.301-3.325-.433-12.76-.391-14.716.684-.388 2.92-1.08 3.086-1.108.006 0-.005.085.01.086.925.043 4.123.225 6.434.77.167.04.273.153.325.348.153.562.458 1.967.506 2.186-.045.039-.274.169-1.306.169-.336 0-.729-.014-1.17-.042a7.772 7.772 0 00-.489-.016c-.96 0-1.743.2-2.265.581-.402.292-.649.699-.662 1.089-.053.789.357 1.277 1.253 1.492 1.242.297 3.048.586 3.366.636l.888 2.28c-.959.068-2.624.219-3.691.495-1.485.383-1.586 1.33-1.705 2.425l-.014.136c-.097.88-.019 2.747.039 3.59a26.15 26.15 0 01-.621.007c-1.683 0-3.144-.167-3.594-.408z"
          fill="url(#f3d_svg__a)"
          transform="translate(3 1)"
        />
        <use fill="url(#f3d_svg__c)" xlinkHref="#f3d_svg__b" transform="translate(11.063 4.243)" />
        <path
          d="M9.932 8.457H9.59c-1.658 3.522 2.489 11.115 2.507 11.154-.064-.91-.14-2.789-.044-3.662.128-1.164.171-2.121 1.673-2.51 1.127-.29 2.944-.443 3.783-.501-.093-.068-.722-.395-4.178-.35-2.108.027-1.99-2.126-.456-2.19 1.344-.057 3.708.143 3.708.143s-2.046-.33-3.423-.66c-.653-.155-1.266-.504-1.204-1.424H9.933z"
          fill="url(#f3d_svg__d)"
          transform="translate(3 1)"
        />
        <path
          d="M10.248 7.49c-.262.27-.491.583-.676.972l.138.158 2.105.019.14-.184c.023-.67.821-1.752 3.354-1.593 2.52.159 2.562-.182 2.562-.182s-1.716-.57-3.64-.57c-1.415 0-2.943.308-3.983 1.38"
          fill="url(#f3d_svg__e)"
          transform="translate(3 1)"
        />
        <path
          d="M15.096 20.61l-.107-.167-.13-.2c-.05-.08-.11-.168-.173-.272l-.21-.34c-.078-.123-.157-.259-.243-.404-.085-.144-.177-.298-.27-.463l-.142-.253a12.088 12.088 0 01-.145-.266c-.098-.183-.201-.373-.3-.572l-.155-.303-.153-.317-.077-.161c-.027-.054-.05-.11-.076-.165l-.154-.337c-.05-.115-.1-.23-.149-.347-.048-.118-.098-.236-.145-.357a19.2 19.2 0 01-.528-1.507c-.08-.26-.152-.526-.22-.792a13.343 13.343 0 01-.387-2.446 10.68 10.68 0 01.011-1.599 9.485 9.485 0 01.235-1.477 8.79 8.79 0 01.413-1.274 7.835 7.835 0 01.99-1.736 6.508 6.508 0 01.459-.54l.035-.036-.035.037a6.597 6.597 0 00-.446.549 7.541 7.541 0 00-.472.73 8.418 8.418 0 00-.884 2.284 10.097 10.097 0 00-.254 2.252c-.001.266.008.534.026.804.034.54.109 1.087.212 1.627.052.27.11.54.175.805a17.557 17.557 0 00.738 2.293c.046.12.095.238.143.356.05.116.098.232.146.347l.15.337.073.166.076.161.15.317.15.305c.097.2.199.39.294.574.094.184.192.356.282.522.088.166.178.321.261.467.083.146.16.283.236.407l.204.344c.124.207.225.367.293.477l.103.17"
          fill="#FDBC5F"
        />
        <path
          d="M13.32 12.587c3.455-.045 4.095.283 4.188.351l-.926-2.397s-1.825-.155-3.18-.155c-.191 0-.373.003-.538.01-1.534.065-1.653 2.218.455 2.191z"
          fill="url(#f3d_svg__f)"
          transform="translate(3 1)"
        />
        <path
          d="M20.871 7.68s-.232-.073-.647-.169a14.576 14.576 0 00-1.737-.298 12.134 12.134 0 00-1.175-.072 8.654 8.654 0 00-1.308.08c-.45.065-.91.174-1.35.352a3.899 3.899 0 00-1.216.756 3.446 3.446 0 00-.473.543 3.674 3.674 0 00-.35.623c-.096.217-.17.442-.227.668a5.103 5.103 0 00-.12.678c-.05.45-.045.891-.013 1.306a11.96 11.96 0 00.152 1.165 21.754 21.754 0 00.398 1.717c.056.206.102.367.133.477l.048.168-.054-.166a22.802 22.802 0 01-.36-1.212 16.69 16.69 0 01-.223-.972c-.07-.36-.133-.752-.167-1.17a7.14 7.14 0 01.005-1.322c.025-.228.062-.46.12-.69.059-.23.137-.458.235-.679.1-.22.22-.434.36-.635.142-.2.304-.386.485-.553.361-.336.792-.59 1.24-.768.45-.177.915-.283 1.37-.344a8.7 8.7 0 011.316-.07c.42.007.815.04 1.178.084a14.138 14.138 0 012.38.503"
          fill="#FDBC5F"
        />
        <path
          d="M19.582 11.54l-.85-.042-.412-.02c-.146-.008-.3-.012-.46-.02a181.2 181.2 0 00-.242-.01l-.249-.008c-.167-.005-.337-.013-.507-.014l-.255-.004-.127-.002a2.127 2.127 0 00-.126 0l-.49.006-.118.009c-.02 0-.038.006-.056.008a1.303 1.303 0 00-.268.068c-.134.05-.252.122-.346.204-.023.021-.047.04-.067.063l-.03.033-.015.016-.013.017c-.018.023-.035.044-.051.067a6.262 6.262 0 00-.042.066 2.867 2.867 0 01-.034.066l-.016.032-.013.032-.022.06-.016.056c-.01.035-.015.068-.02.097l-.007.04c0 .011-.002.022-.003.032l-.004.061v-.061l.002-.033c0-.013.002-.026.004-.04.003-.03.006-.062.016-.099l.013-.058a3.146 3.146 0 01.031-.095l.015-.032c.004-.012.01-.023.015-.034a1 1 0 01.231-.314 1.14 1.14 0 01.354-.223c.07-.028.143-.049.22-.066.039-.007.078-.016.117-.02l.119-.011.245-.006.25-.006h.126l.127.001.255.003c.17.002.34.011.508.016l.25.01.242.014c.16.01.314.018.46.03l.411.03c.128.01.244.022.348.031l.267.026.172.018.06.007"
          fill="#FDBC5F"
        />
        <g fill="#FFF" fillRule="nonzero">
          <path d="M19.364 28.22c.235 0 .428-.022.58-.068.27-.084.491-.247.664-.487.137-.193.236-.44.297-.74.035-.18.052-.347.052-.501 0-.592-.126-1.05-.379-1.378-.253-.327-.66-.49-1.221-.49h-1.234v3.664h1.24zM17.424 24h2.08c.705 0 1.253.233 1.642.699.347.42.52.958.52 1.614 0 .507-.102.965-.307 1.375-.361.723-.982 1.085-1.862 1.085h-2.073V24zM15.247 28.773c-.538 0-.928-.15-1.17-.452-.244-.302-.365-.668-.365-1.1h.598c.025.3.08.518.165.654.148.244.416.366.804.366.301 0 .543-.082.725-.246a.816.816 0 00.273-.635c0-.32-.096-.543-.287-.67-.192-.128-.459-.192-.8-.192a4.213 4.213 0 00-.235.007v-.516a2.797 2.797 0 00.28.017c.214 0 .39-.035.527-.104.242-.121.363-.337.363-.648 0-.231-.08-.41-.242-.535a.89.89 0 00-.562-.188c-.382 0-.646.13-.792.39-.08.142-.126.345-.137.608h-.565c0-.345.067-.639.203-.881.233-.432.643-.648 1.23-.648.464 0 .823.105 1.078.316.254.21.381.516.381.915 0 .285-.075.517-.226.694a.948.948 0 01-.362.259c.24.067.427.196.561.387.135.191.202.425.202.702 0 .442-.143.803-.43 1.082-.285.278-.691.418-1.217.418zM10 24h3.182v.585h-2.56v1.449h2.25v.568h-2.25v2.17H10z" />
        </g>
      </g>
    </svg>
  );
});
export default SvgF3D;
SvgF3D.iconName = 'f3d';
SvgF3D.displayName = 'SvgF3D';
